'use strict';

var AnalysisMetricService = function AnalysisMetricService(AnalysisMetric, constants) {
  var metricEntities = {};
  metricEntities[constants.MARKET_SCREEN] = new AnalysisMetric(constants.MARKET_SCREEN);
  metricEntities[constants.FLIGHT_SCREEN] = new AnalysisMetric(constants.FLIGHT_SCREEN);
  metricEntities[constants.STRATEGY_SCREEN] = new AnalysisMetric(constants.STRATEGY_SCREEN);
  metricEntities[constants.RULE_SCREEN] = new AnalysisMetric(constants.RULE_SCREEN);
  metricEntities[constants.DATA_EXTRACT_SCREEN] = new AnalysisMetric(constants.DATA_EXTRACT_SCREEN);
  metricEntities[constants.SYSTEM_STATUS_SCREEN] = new AnalysisMetric(constants.SYSTEM_STATUS_SCREEN);
  metricEntities[constants.ENTITY_SCREEN] = new AnalysisMetric(constants.ENTITY_SCREEN);
  metricEntities[constants.EVENTS_SCREEN] = new AnalysisMetric(constants.EVENTS_SCREEN);
  metricEntities[constants.DEMAND_TRANSPARENCY_SCREEN] = new AnalysisMetric(constants.DEMAND_TRANSPARENCY_SCREEN);
  metricEntities[constants.FARES_SCREEN] = new AnalysisMetric(constants.FARES_SCREEN);
  metricEntities[constants.DASHBOARD_SCREEN] = new AnalysisMetric(constants.DASHBOARD_SCREEN);
  metricEntities[constants.SEASONALITY_SCREEN] = new AnalysisMetric(constants.SEASONALITY_SCREEN);
  metricEntities[constants.ROM_ANALYSIS_SCREEN] = new AnalysisMetric(constants.ROM_ANALYSIS_SCREEN);
  metricEntities[constants.ROM_SUMMARY_SCREEN] = new AnalysisMetric(constants.ROM_SUMMARY_SCREEN);
  metricEntities[constants.USER_MANAGEMENT_SCREEN] = new AnalysisMetric(constants.USER_MANAGEMENT_SCREEN);
  metricEntities[constants.PRICING_ANALYSIS_SCREEN] = new AnalysisMetric(constants.PRICING_ANALYSIS_SCREEN);
  metricEntities[constants.PRICING_SUMMARY_SCREEN] = new AnalysisMetric(constants.PRICING_SUMMARY_SCREEN);
  metricEntities[constants.CALIBRATION_ANALYSIS_SCREEN] = new AnalysisMetric(constants.CALIBRATION_ANALYSIS_SCREEN);
  metricEntities[constants.ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN] = new AnalysisMetric(constants.ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN);
  function getAnalysisMetric(screen) {
    return metricEntities[screen];
  }
  return {
    getAnalysisMetric: getAnalysisMetric
  };
};
AnalysisMetricService.$inject = ['AnalysisMetricFactory', 'DataRetrieverConstantsService'];
module.exports = AnalysisMetricService;